import React from 'react';
import { Section, SectionHeading } from './Shared';
import { KanjiBackdrop } from './Ornaments';
import { costs } from '../data/costs';
export function CostComparison() {
  return <Section data-id="element-19" data-mp="26umavvzn5bkq">
      <KanjiBackdrop glyphs={['失', '得', '時', '果', '行']} data-id="element-20" data-mp="26uck466rv0dz" />
      <SectionHeading character="計" className="mb-10" data-id="element-21" data-mp="26srpkgkgjhg4">
        ¿CUÁNTO CUESTA NO TENERLO?
      </SectionHeading>
      <div className="mx-auto max-w-4xl" data-id="element-22" data-mp="21tyc2o567qfy">
        <div className="hidden grid-cols-2 gap-5 px-5 pb-3 font-serif text-base font-bold uppercase tracking-[0.06em] md:grid" data-id="element-23" data-mp="2yl0hr898lnmw">
          <span className="text-brand-forest" data-id="element-24" data-mp="2ul85olkmwzcs">Sin el Atlas</span>
          <span className="text-brand-burgundy" data-id="element-25" data-mp="2pkkf210bikj3">
            Lo que le cuesta a tu práctica
          </span>
        </div>
        <div className="space-y-3" data-id="element-26" data-mp="2klr1y9oy0vjg">
          {costs.map(([without, result]) => <div key={without} className="paper-card grid gap-2 rounded-sm border border-brand-gold/35 p-5 md:grid-cols-2 md:gap-5" data-id="element-27" data-mp="1e78cruk7i9z1">
              <p className="text-sm font-semibold text-brand-ink" data-id="element-28" data-mp="2la9bvswjbis4">{without}</p>
              <p className="border-l border-brand-gold/40 pl-3 text-sm font-medium text-brand-burgundy md:pl-5" data-id="element-29" data-mp="2pce02c47rn7d">
                {result}
              </p>
            </div>)}
        </div>
      </div>
      <blockquote className="mx-auto mt-14 max-w-4xl text-center font-display text-2xl font-semibold italic leading-relaxed text-brand-forest md:text-3xl" data-id="element-30" data-mp="2gbfwtw1lnjpu">
        “El terapeuta que tiene un sistema aplica con confianza. El que aplica
        con confianza genera resultados. El que genera resultados crece.”
      </blockquote>
    </Section>;
}